<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>账单列表</div>
      <el-button
        class="icon-fresh"
        size="mini"
        icon="el-icon-refresh"
        @click="fetchData"
        >刷新</el-button
      >
    </div>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>筛选查询</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
            >{{ filterFold ? "展开筛选" : "收起筛选" }}</el-button
          >
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold" style="padding: 8px">
            <el-form :inline="true" :model="form" class="demo-form-inline">
              <el-form-item label="商家ID">
                <el-input
                  v-model="form.supply_id"
                  placeholder="商家ID"
                  @keyup.native.enter="search"
                ></el-input>
              </el-form-item>
              <el-form-item label="商家名">
                <el-input
                  v-model="form.supply_name"
                  placeholder="商家"
                  @keyup.native.enter="search"
                ></el-input>
              </el-form-item>
              <el-form-item label="账单编号">
                <el-input
                  v-model="form.bill_no"
                  placeholder="账单编号"
                  @keyup.native.enter="search"
                ></el-input>
              </el-form-item>
              <el-form-item label="账单状态">
                <el-select v-model="form.bill_status" placeholder="账单状态">
                  <el-option label="全部" value></el-option>
                  <el-option
                    v-for="item in statusOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="结算方式">
                <el-select v-model="form.clearing_form" placeholder="结算方式">
                  <el-option label="全部" value></el-option>
                  <el-option
                    v-for="item in settlementOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="是否 0 元账单">
                <el-select
                  v-model="form.is_zero_bill"
                  placeholder="是否 0 元账单"
                >
                  <el-option label="全部" value></el-option>
                  <el-option label="是" :value="1"></el-option>
                  <el-option label="否" :value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="账期">
                <el-date-picker
                  v-model="form.reporting_period"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="账单生成时间">
                <el-date-picker
                  v-model="form.created_at"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="账期类型">
                <el-select v-model="form.period_profit" placeholder="请选择">
                  <el-option
                    v-for="item in PERIOD_PROFIT_STATUS"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="search">查询</el-button>
                <el-button type="default" @click="reset">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>

    <!-- 表格 -->
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
            position: relative;
          "
        >
          <div>数据列表：</div>
          <div style="position: absolute; top: 10px; right: 10px">
            <el-button
              style="margin-left: 8px"
              type="warning"
              size="mini"
              @click="submitInBatchHandler"
            >
              批量提交</el-button
            >
            <el-button
              style="margin-left: 8px"
              type="warning"
              size="mini"
              @click="batchAudit"
              >批量审核</el-button
            >
            <el-button
              style
              type="success"
              size="mini"
              @click="output({ is_excel: '1' })"
            >
              导出账单列表</el-button
            >
            <el-button
              style="margin-left: 8px"
              type="success"
              size="mini"
              @click="output({ is_excel_sales: '1' })"
              >导出销量汇总明细</el-button
            >
            <el-button
              style="margin-left: 8px"
              type="success"
              size="mini"
              @click="output({ is_excel_flowing: '1' })"
              >导出收款流水明细</el-button
            >
          </div>
        </div>
        <div style="margin-bottom: 0">
          <el-table
            ref="multipleTable"
            v-loading="tableLoading"
            height="600"
            :data="tableList"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              align="center"
              type="selection"
              width="55"
              :selectable="checkboxInit"
            ></el-table-column>

            <el-table-column
              prop="reporting_period"
              label="账期"
              show-overflow-tooltip
              align="center"
              width="170"
            ></el-table-column>
            <el-table-column
              prop="period_profit"
              label="账期类型"
              show-overflow-tooltip
              align="center"
              width="170"
            ></el-table-column>
            <el-table-column
              prop="bill_no"
              label="账单编号"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="created_at"
              label="账单生成时间"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="supply_name"
              label="商家名称"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="clearing_form"
              label="结算方式"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column label="账单状态" align="center">
              <template #default="scope">
                <el-tooltip
                  :disabled="!scope.row.remark"
                  effect="dark"
                  :content="scope.row.remark"
                  placement="top-start"
                >
                  <div
                    :style="{
                      color:
                        scope.row.bill_status ===
                          STATUS.PENDING_BUSINESS_REVIEW && scope.row.remark
                          ? '#f00'
                          : '#606266',
                    }"
                  >
                    {{ scope.row.bill_status_name }}
                  </div>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              prop="amount_price"
              label="总结算金额"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="deduction_price"
              label="已抵扣/支付金额"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="stay_deduction_price"
              label="待抵扣/支付金额"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="updated_at"
              label="最后更新时间"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              label="操作"
              show-overflow-tooltip
              align="center"
              fixed="right"
            >
              <template #default="scope">
                <el-button
                  type="text"
                  size="small"
                  @click="handleDetail(scope.row)"
                  >查看详情</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="text-align: right; padding: 25px">
          <el-pagination
            :page-sizes="[50, 100, 200, 500, 1000]"
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, jumper ,sizes"
            :total="total"
            :page-size="form.pagesize"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </div>
      </el-col>
    </el-row>
    <div v-if="payVisible">
      <pay-tem
        :ids="profit_bill_id"
        :url="url2"
        :pay_num="pay_num"
        :pay_money="pay_money"
        @onCloseDialog="onCloseDialog"
      ></pay-tem>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import apiBaseURL from "@/utils/baseUrl.js";

import PayTem from "../wcgorder/components/PayOrderTem.vue";

import * as vendorProfitConcessionApi from "@/controller/vendorProfitConcession3461.js";

const STATUS = {
  PENDING_BUSINESS_REVIEW: 1, // 业务待审核
  PENDING_FINANCIAL_REVIEW: 2, // 财务待审核
  PENDING_VENDOR_CONFIRM: 3, // 商家待确认
  PENDING_PURCHASE_ORDER_DEDUCTION: 4, // 代采单待抵扣
  BILLS_TO_BE_PAID: 5, // 账单待支付
  DONE: 6, // 已完成
};

const PERIOD_PROFIT_STATUS = [
  {
    label: "全部",
    value: "0",
  },
  {
    label: "按天生成",
    value: "2",
  },
  {
    label: "按月生成",
    value: "1",
  },
];

export default {
  name: "VendorProfitConcessionList",
  components: {
    PayTem,
  },
  data() {
    const startDate = `${dayjs().year()}-${
      dayjs().month() + 1 > 9 ? dayjs().month() + 1 : `0${dayjs().month() + 1}`
    }-01`;
    const endDate = dayjs().format("YYYY-MM-DD");
    return {
      PERIOD_PROFIT_STATUS,
      BILL_TYPES: {
        GOODS_BEFORE_PAY_AFTER: 0, // 先货后款
        FRONT_WAREHOUSE: 1, // 前置仓
        NORMAL_TAKE_GOODS: 2, // 常规拿货
        ALLOTMENT: 3, // 配发出库
      },
      resData: null,
      form: {
        pagesize: 100,
        page: 1,
        is_dispense: "",
        supply_id: "",
        supply_name: "",
        bill_no: "",
        bill_status: null,
        clearing_form: null,
        is_zero_bill: null,
        reporting_period: [],
        created_at: [startDate, endDate],
        period_profit: "",
      },
      loading: false,
      where: -1,
      curPage: 1,
      tableLoading: false,
      filterFold: false,
      pay_num: 0,
      pay_money: 0,
      profit_bill_id: [],
      payVisible: false,
      tableList: [],
      statusOptions: [],
      settlementOptions: [],
      total: 0,
      multipleSelection: [],
      STATUS,
    };
  },
  computed: {},
  watch: {
    "form.reporting_period": function formReportingPeriod(newVal) {
      if (!newVal) {
        this.form.reporting_period = [];
      }
    },
    "form.created_at": function formReportingPeriod(newVal) {
      if (!newVal) {
        this.form.created_at = [];
      }
    },
  },
  created() {
    this.fetchData();
    this.getOptions();
  },
  methods: {
    handlePay() {
      if (this.pay_num === 0) {
        this.$message.error("请选择订单");
      } else {
        this.loading = true;
        this.$http
          .post("/erp/SupplySettleBill/payOrder", {
            ids: this.profit_bill_id,
            furinfo: "代用户支付服装商家货款",
          })
          .then((res) => {
            if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
            } else {
              this.$message.success(res.data.msg);
              this.fetchData();
            }
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    onCloseDialog() {
      this.payVisible = false;
      this.fetchData();
    },
    defaultDate() {
      const endDate = new Date();
      const endM =
        endDate.getMonth() + 1 < 10
          ? `0${endDate.getMonth() + 1}`
          : endDate.getMonth() + 1;
      const end = `${endDate.getFullYear()}-${endM}-${endDate.getDate()}`;

      const startDate = new Date();
      startDate.setDate(startDate.getDate() - 3);
      const startM =
        startDate.getMonth() + 1 < 10
          ? `0${startDate.getMonth() + 1}`
          : startDate.getMonth() + 1;
      const start = `${startDate.getFullYear()}-${startM}-${startDate.getDate()}`;
      return [start, end];
    },
    output(outputParams) {
      vendorProfitConcessionApi
        .getList({ ...this.form, ...outputParams })
        .then((res) => {
          console.log("🚀 : .then : res", res);

          window.open(apiBaseURL + res.file);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    checkboxInit(row) {
      return (
        row.bill_status === STATUS.PENDING_BUSINESS_REVIEW ||
        row.bill_status === STATUS.PENDING_FINANCIAL_REVIEW
      );
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;

      this.profit_bill_id = val.map((bill) => bill.id);
    },
    onSubmit() {},
    handleDetail(row) {
      const t = Date.parse(new Date());
      this.$router.push(
        `/home/vendor-profit-concession-detail/${row.id}?t=${t}`
      );
      // window.open(`#/home/vendor-profit-concession-detail/${row.id}`);
    },
    handleCurrentChange(val) {
      this.form.page = val;
      this.fetchData();
    },
    handleClick(row, index) {
      const curRow = this.resData.list[index];
      this.$router.push(
        `/home/stockdetail/${row.goods_no}?co_id=${curRow.co_id}&where=${curRow.where}&si_id=${curRow.si_id}`
      );
    },
    search() {
      this.form.page = 1;
      this.loading = true;
      this.fetchData();
    },
    selectOrigin(key) {
      this.form.origin = key;
      this.origin = key;
      this.loading = true;
      this.$http.post(this.url, this.form).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    selectWhere(key) {
      this.form.where = key;
      this.where = key;
      this.loading = true;
      this.$http.post(this.url, this.form).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    fetchData() {
      this.loading = true;
      vendorProfitConcessionApi
        .getList(this.form, { isMock: false })
        .then((res) => {
          this.tableList = res.list;
          this.total = res.count;
        })
        .catch(this.$noop)
        .finally(() => {
          this.loading = false;
        });
    },
    handleSizeChange(e) {
      this.form.pagesize = e;
      this.fetchData();
    },
    mergeBill() {
      this.$confirm("确定需要合并账单？", "提示", {
        center: true,
      })
        .then(() => {
          this.$http
            .post("/erp/SupplySettleBill/mergeBill", {
              billIds: this.profit_bill_id,
            })
            .then((res) => {
              if (res.data.code !== 200) {
                this.$message.error(res.data.msg);
                return;
              }
              this.$message.success("操作成功");
              this.fetchData();
            });
        })
        .catch(() => {
          this.$message.info("已取消");
        });
    },
    // 批量审核
    batchAudit() {
      if (this.profit_bill_id.length < 1) {
        this.$message({
          message: "请勾选需要批量审核的前置仓单据",
          type: "error",
        });
        return;
      }

      const canAuditInBatch = this.multipleSelection.every((bill) => {
        if (bill.bill_status === STATUS.PENDING_FINANCIAL_REVIEW) {
          return true;
        }
        return false;
      });
      if (!canAuditInBatch) {
        this.$message({
          message: "仅「财务待审核」状态可批量提交，请重新选择！",
          type: "error",
        });
        return;
      }
      this.$confirm("确定批量审核？", "提示", {
        center: true,
      })
        .then(() => {
          vendorProfitConcessionApi
            .batchBillExamine({
              profit_bill_id: this.profit_bill_id,
            })
            .then(() => {
              this.$message.success("审核成功");
              this.fetchData();
            });
        })
        .catch(() => {
          this.$message.info("已取消审核");
        });
    },

    // 批量提交
    submitInBatchHandler() {
      if (this.profit_bill_id.length < 1) {
        this.$message({
          message: "请勾选需要批量提交的账单",
          type: "error",
        });
        return;
      }
      const canSubmitInBatch = this.multipleSelection.every((bill) => {
        if (bill.bill_status === STATUS.PENDING_BUSINESS_REVIEW) {
          return true;
        }
        return false;
      });

      if (!canSubmitInBatch) {
        this.$message({
          message: "仅「业务待审核」状态可批量提交，请重新选择！",
          type: "error",
        });
        return;
      }
      this.$confirm("确定批量提交？", "提示", {
        center: true,
      })
        .then(() => {
          vendorProfitConcessionApi
            .batchBillSubmit(
              { profit_bill_id: this.profit_bill_id },
              { useDataField: false }
            )
            .then(() => {
              this.$message.success("提交成功");
              this.fetchData();
            });
        })
        .catch(() => {
          this.$message.info("已取消提交");
        });
    },
    getOptions() {
      vendorProfitConcessionApi
        .sectionInitOption({}, { isMock: false })
        .then((res) => {
          this.statusOptions = res.status;
          this.settlementOptions = res.clearing;
        });
    },
    reset() {
      this.form = this.$options.data().form;
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 12px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/VendorProfitConcessionList/VendorProfitConcessionList.vue